import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Select as MaterialSelect } from '@material-ui/core';

const styles = {
  select: {
    width: '100%',
    marginBottom: '10px',
  },
};

class Select extends Component {
  render() {
    const {
      placeholder, value, onChange, multiple, displayEmpty, renderValue, children, ...others
    } = this.props;

    return (
      <MaterialSelect
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        multiple={multiple}
        displayEmpty={displayEmpty}
        renderValue={renderValue}
        style={styles.select}
        {...others}
      >
        {children}
      </MaterialSelect>
    );
  }
}

Select.propTypes = {
  placeholder: PropTypes.string,
  value: PropTypes.any.isRequired,
  onChange: PropTypes.func,
  multiple: PropTypes.bool,
  displayEmpty: PropTypes.bool,
  renderValue: PropTypes.func,
  children: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.array,
  ]),
};

Select.defaultProps = {
  placeholder: '',
  onChange: () => {},
  multiple: false,
  displayEmpty: false,
  renderValue: null,
  children: null,
};

export default Select;
